import styled from 'styled-components';

export const InteractionContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: calc(100% - 10px);
  margin: 0 auto;
  gap: 10px;
  height: calc(100vh - 150px);
  max-height: calc(100vh - 150px);
  overflow-y: auto;
  padding-right: 10px;
  border: 0px solid red;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #999;
  }
`;

export const RestartButton = styled.button`
  padding: 10px 20px;
  font-size: 1em;
  color: white;
  background-color: #6c757d;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin: 10px auto;
  display: block;
  transition: background-color 0.3s;

  &:hover {
    background-color: #5a6268;
  }
`;
